import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react'

const HeightPredictorLayout = (props) => (
  <>
    <Placeholder name="main-layout" rendering={props.rendering} itemid={props.itemidkey} />
    </>
);

export default HeightPredictorLayout;
